import React from 'react'
import ContactBanner from '../../Components/Contact/ContactBanner/ContactBanner'
import ContactItem from '../../Components/Contact/ContactItem/ContactItem'
import SEO from '../../common/SEO/SEO'

const contactSchema = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "name": "Contact Maya Wears Customer Care",
  "description": "Reach out to Maya Wears customer support team in Nepal. Order inquiries, delivery assistance, sizing questions, and boutique visits.",
  "url": "https://mayawears.com.np/contact",
  "mainEntity": {
    "@type": "ContactPoint",
    "telephone": "+977-9849531357",
    "contactType": "customer service",
    "availableLanguage": ["en", "ne"],
    "areaServed": "NP"
  }
};

const ContactPage = () => {
  return (
    <div>
      <SEO
        title="Contact Customer Support & Service"
        description="Get in touch with Maya Wears customer service. Inquiries about orders, deliveries, returns, or personalized styling advice in Nepal."
        canonical="https://mayawears.com.np/contact"
        keywords="contact Maya Wears, Maya Wears phone number, customer care Nepal, fashion support Kathmandu, WhatsApp clothing Nepal"
        schema={contactSchema}
      />
      <ContactBanner/>
      <ContactItem/>
    </div>
  )
}

export default ContactPage